export const resourceName = {
    singular: 'customer',
    plural: 'customers',
};

export const resourceNameVariantsGrid = {
    singular: 'Variant',
    plural: 'Variants',
};

export const initialVariantStates = {
    rows: []
}

export const excludeKeysFromValidation = ['source_product_id', 'container_id', 'target_marketplace', 'shop_id', 'isParent', 'type', 'isVariant']